import { useMemo } from "react";
import { useAuth, ROLES_NAMESPACE } from "../context/AuthProvider.tsx";

export function useAdminRole() {
  const { isAdmin: contextIsAdmin, user } = useAuth();

  const { isAdmin, roles, source } = useMemo(() => {
    const ctxRoles = user?.[ROLES_NAMESPACE] || [];
    if (contextIsAdmin || (Array.isArray(ctxRoles) && ctxRoles.includes("Admin"))) {
      return { isAdmin: true, roles: ctxRoles, source: "context" as const };
    }

    let storedUser = null;
    try {
      storedUser = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      storedUser = null;
    }
    const storedRoles = storedUser?.[ROLES_NAMESPACE] || [];

    return {
      isAdmin: Array.isArray(storedRoles) && storedRoles.includes("Admin"),
      roles: storedRoles,
      source: "localStorage" as const,
    };
  }, [contextIsAdmin, user]);

  return { isAdmin, roles, source };
}
